import { openDB } from 'idb';

export const initDB = async () => {
    return openDB('HelpGuideDB', 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains('pdf_images')) {
                db.createObjectStore('pdf_images', { keyPath: 'key' }); 
            }
        },
    });
};

// Store Image as Blob
export const storePDFImage = async (key, blob) => {
    try {
        if (!blob || !(blob instanceof Blob) || blob.size === 0) {
            console.error("Invalid Blob - Not storing:", blob);
            return;
        }
        const db = await initDB();
        const tx = db.transaction('pdf_images', 'readwrite');
        const store = tx.objectStore('pdf_images');
        const entry = { key, blob }; 
        await store.put(entry);
        await tx.done;
    } catch (error) {
        console.error("Error storing image in IndexedDB:", error);
    }
};

// Retrieve Image as Blob
export const getPDFImage = async (key) => {
    try {
        const db = await initDB();
        let entry = await db.get('pdf_images', key);

        if (!entry || !entry.blob) {
            console.error("No valid Blob found for key:", key);
            return null;
        }

        let blob = entry.blob; 
        return blob;
    } catch (error) {
        console.error("Error retrieving image from IndexedDB:", error);
        return null;
    }
};

// Debug IndexedDB Contents
export const debugIndexedDB = async () => {
    try {
        const db = await initDB();
        const tx = db.transaction('pdf_images', 'readonly');
        const store = tx.objectStore('pdf_images');
        const allEntries = await store.getAll();
        return allEntries;
    } catch (error) {
        console.error("Error reading IndexedDB:", error);
    }
};

// Fetch Image as Blob from URL
export const fetchImageAsBlob = async (url) => {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
        return await response.blob();
    } catch (error) {
        console.error("Error fetching image as Blob:", error);
        return null;
    }
};

export const deleteWholeDatabase = async () => {
    try {
        await indexedDB.deleteDatabase('HelpGuideDB');
    } catch (error) {
        console.error("❌ Error deleting IndexedDB:", error);
    }
};